import { render, staticRenderFns } from "./RemoveBank.vue?vue&type=template&id=e49d3a0c&scoped=true"
import script from "./RemoveBank.vue?vue&type=script&lang=js"
export * from "./RemoveBank.vue?vue&type=script&lang=js"
import style0 from "./RemoveBank.vue?vue&type=style&index=0&id=e49d3a0c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e49d3a0c",
  null
  
)

export default component.exports